module.exports = __webpack_public_path__ + "img/choose-time-image.1b0c51a5.svg";